import { DisplayDate } from '@tock/time';
import { LocalDate } from 'js-joda';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { getTitleForType } from 'utils/importantDateUtils';
import ImportantDateIcon from 'components/profile/ImportantDateIcon';

interface OwnProps {
  date: LocalDate;
  type: core.PatronProfile.DayType;
}

const ImportantDate = ({ type, date }: OwnProps) => {
  const title = getTitleForType(type);
  return (
    <div className="ImportantDate">
      <ImportantDateIcon type={type} />
      <div className="ImportantDate-text">
        <div className="ImportantDate-date">
          <Typography variant="body02Strong">
            <DisplayDate dateValue={date} showYear={false} displayMonthAs="long" />
          </Typography>
        </div>
        <div className="ImportantDate-type">
          <Typography variant="body02">{title}</Typography>
        </div>
      </div>
    </div>
  );
};

export default ImportantDate;
